import AdminPanelLayout from "../../../components/AdminPanel/AdminPanelLayout/AdminPanelLayout";

import ViewFullCourse from "../../../components/UserDashboard/ViewCourse/ViewFullCourse";

const ViewCourse = () => {
  return (
    <AdminPanelLayout>
      <ViewFullCourse />
    </AdminPanelLayout>
  );
};

export default ViewCourse;
